// import { UserManager, WebStorageStateStore } from 'oidc-client';


// const oidcConfig = {
//   authority: 'http://localhost:9000/application/o/mercury-1/', // Base URL of your Authentik server
//   client_id: '1EGE8odaip0gM0nVPeF31PT6Dzvw4GFAG2hoZPBE', // Client ID from Authentik
//   redirect_uri: 'http://localhost:3000/auth/callback/local', // Your React app's callback URL
//   response_type: 'code',
//   scope: 'openid profile email entitlements',
//   post_logout_redirect_uri: 'http://localhost:3000/Not-Found', // Where to redirect after logout
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
// };

// const localoidcConfig = {
//   authority: 'http://localhost:9000/application/o/mercury-2/', // Base URL of your Authentik server
//   client_id: 'iVI3CF7gsl2sA7WTUihE2mGWEW0RbUvcHXQu4hDu', // Client ID from Authentik
//   redirect_uri: 'http://localhost:3000/auth/callback/remote', // Your React app's callback URL
//   response_type: 'code',
//   scope: 'openid profile email entitlements',
//   post_logout_redirect_uri: 'http://localhost:3000/Not-Found', // Where to redirect after logout
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
// };



// const userManager = new UserManager(oidcConfig);


// export default userManager;

// userManager.ts
import { UserManager, WebStorageStateStore } from 'oidc-client';

interface UserConfigsDetails {
  authority: string;
  client_id: string;
  post_logout_redirect_uri: string;
  redirect_uri: string;
}

const rawUserConfigs = process.env.REACT_APP_ROBOT_AUTH ?? '{}';


export const createUserManager = (robot: string) => {
  let set: boolean = false
  const commonConfig = {
    response_type: 'code',
    scope: 'openid profile email entitlements',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };
  try{
    const parsed = JSON.parse(rawUserConfigs);
    console.log(`Creating Manager for ${robot}`)
    
    let userConfig: Partial<UserConfigsDetails> = {};
    if (robot in parsed){
      userConfig=parsed[robot]
      set = true
    } else {
      console.warn(`Robot config for '${robot}' not found in REACT_APP_ROBOT_AUTH`);
      if (robot !== 'auth'){
        window.location.href="https://tp-portal.mafdigitallab.co.nz/"
      }
    }
    
    if (set) {
      return new UserManager({
        ...commonConfig,
        authority: userConfig.authority,
        client_id: userConfig.client_id,
        post_logout_redirect_uri: userConfig.post_logout_redirect_uri,
        redirect_uri: userConfig.redirect_uri,
      });
    } else {
      return new UserManager({
        ...commonConfig,
        authority: 'http://localhost:9000/application/o/mercury-1/',
        client_id: '1EGE8odaip0gM0nVPeF31PT6Dzvw4GFAG2hoZPBE',
        redirect_uri: 'http://localhost:3000/auth/callback/local',
      });
    }
  } catch (err) {
    console.error("Failed to parse REACT_APP_ROBOT_CONFIGS:", err);
    return new UserManager({
      ...commonConfig,
      authority: 'http://localhost:9000/application/o/mercury-1/',
      client_id: '1EGE8odaip0gM0nVPeF31PT6Dzvw4GFAG2hoZPBE',
      redirect_uri: 'http://localhost:3000/auth/callback/local',
    });
  }
};
